//components
import { Billing } from '@/components/pages/settings/subscription-invoices/UserBilling/Billing';

export function UserBilling() {
    return <Billing />;
}
